var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",class:{ active: _vm.pending.load_single_note }},[_c('div',{staticClass:"square"},[_c('loader-basic-spinner',{staticClass:"blue large"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }